<template>
  <v-container>
    <v-img
      :src="culColour"
      class="logo"
      height="50"
      position="left top"
    />
    <!-- rename the child so we don't recurse -->
    <BeforeYouStartContent />

    <v-btn 
      v-if="canGoBack"
      color="secondary"
      class="btn-gap text-white"
      @click="goBack"
    >
      GO BACK
    </v-btn>
  </v-container>
</template>

<script>
import culColour from "@/assets/cul_colour.png";
import BeforeYouStartContent from '@/components/BeforeYouStart.vue'

export default {
  name: "BeforeYouStartView",
  components: {
    // alias the component to avoid self-recursion
    BeforeYouStartContent,
  },
  data: () => ({
    dialog: false,
    culColour,
    canGoBack: false,
  }),
  mounted() {
    // basic heuristic: if there's history, allow "back"
    this.canGoBack = window.history.length > 1;
  },
  methods: {
    goBack() {
      this.$router.back();
    },
  },
};
</script>

<style>
.logo {
  margin-bottom: 20px;
  max-height: 50px;
}
.btn-gap {
  /* margin-bottom is fine, but use logical property to be RTL-safe */
  margin-block-end: 24px;
  margin-block-start: 16px; /* optional */
}
</style>
